import { APP_ENV, ENVIRONMENT, type Environment } from 'env/environment'

import { AppBar, styled, Theme, Typography } from '@mui/material'

export const getEnvColor = (theme: Theme, env?: Environment) => {
  const environment = env || APP_ENV

  switch (environment) {
    case ENVIRONMENT.TEST:
    case ENVIRONMENT.DEVELOPMENT:
      return theme.palette.envIndicator.dev
    case ENVIRONMENT.STAGING:
      return theme.palette.envIndicator.staging
    case ENVIRONMENT.DDE_SIMULATION:
      return theme.palette.envIndicator.sandbox
    default:
      return 'transparent'
  }
}

export const getEnvBorder = (theme: Theme) => {
  const { TEST, DEVELOPMENT, STAGING, DDE_SIMULATION } = ENVIRONMENT
  if ([TEST, DEVELOPMENT, STAGING, DDE_SIMULATION].some((env) => env === APP_ENV)) {
    return `${theme.spacing(0.5)} solid ${getEnvColor(theme)}`
  }
  return 'none'
}

const generateBannerColor = (theme: Theme, env?: Environment) => {
  const environment = env || APP_ENV

  switch (environment) {
    case ENVIRONMENT.DEVELOPMENT:
    case ENVIRONMENT.TEST:
      return theme.palette.envIndicator.dev
    case ENVIRONMENT.STAGING:
      return theme.palette.envIndicator.staging
    case ENVIRONMENT.DDE_SIMULATION:
      return theme.palette.envIndicator.sandbox
    default:
      return theme.palette.secondary.dark
  }
}

export const ConsoleAppBar = styled(AppBar)(({ theme }) => ({
  borderTop: getEnvBorder(theme)
}))

export const AppVersion = styled(Typography)(() => ({
  fontSize: '0.6em'
}))

export const EnvironmentBadge = styled('p')(({ theme }) => {
  const bgColor = generateBannerColor(theme) as string
  const display = APP_ENV === ENVIRONMENT.PRODUCTION ? 'none' : 'block'

  return {
    backgroundColor: bgColor,
    borderRadius: theme.spacing(0.5),
    color: theme.palette.getContrastText(bgColor),
    padding: theme.spacing(0.25, 1),
    fontSize: '0.75rem',
    lineHeight: 1.67,
    width: 'max-content',
    display
  }
})

export const PlatformBadge = styled('p')(({ theme }) => {
  return {
    backgroundColor: theme.palette.consoleGrey[1300],
    borderRadius: theme.spacing(0.5),
    fontWeight: 600,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    padding: theme.spacing(0.25, 1),
    fontSize: '0.75rem',
    lineHeight: 1.67,
    letterSpacing: '0.5px',
    width: 'max-content',
    display: 'block',
    marginLeft: theme.spacing(1),
    whiteSpace: 'nowrap'
  }
})
